<svg id="Ebene_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.14 76.5"
    ><defs
        ><style>
            .cls-1 {
                fill: #1d1d1b;
            }
        </style></defs
    ><g id="Ebene_1-2"
        ><path
            class="cls-1"
            d="M26.57,76.5h-.01c-.54,0-1.05-.26-1.38-.69C5.98,50.68,0,40.6,0,26.57S11.92,0,26.57,0s26.57,11.92,26.57,26.57-6.6,25.63-25.2,49.26c-.33,.42-.84,.67-1.38,.67ZM26.57,3.5C13.85,3.5,3.5,13.85,3.5,26.57s5.52,22.21,23.09,45.32c18.27-23.37,23.05-32.9,23.05-45.32S39.29,3.5,26.57,3.5Zm0,40.6c-9.54,0-17.3-7.76-17.3-17.3S17.03,9.5,26.57,9.5s17.3,7.76,17.3,17.3-7.76,17.3-17.3,17.3Zm0-31.1c-7.61,0-13.8,6.19-13.8,13.8s6.19,13.8,13.8,13.8,13.8-6.19,13.8-13.8-6.19-13.8-13.8-13.8Z"
        /></g
    ></svg
>
